import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import type { PdfPageProps } from "./types";

// Use CDN for PDF.js worker to avoid webpack bundling issues
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

const PdfPage = ({ pdfPath, scale, width }: PdfPageProps) => {
  const [numPages, setNumPages] = useState<number>(0);

  return (
    <Document
      file={pdfPath}
      className={"pdf-viewer"}
      onLoadSuccess={({ numPages }) => setNumPages(numPages)}
    >
      {Array.from({ length: numPages }, (_, index) => (
        <Page
          key={`page_${index + 1}`}
          scale={scale}
          width={width}
          pageNumber={index + 1}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      ))}
    </Document>
  );
};

export default PdfPage;
